import { render, staticRenderFns } from "./addKnow.vue?vue&type=template&id=29f16afc&scoped=true&"
import script from "./addKnow.vue?vue&type=script&lang=js&"
export * from "./addKnow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f16afc",
  null
  
)

export default component.exports